// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3mfH4","tab":"ProcedureTabs_tab__3WKt9"};